import React, { useState } from 'react';
import '../assets/styles/Contact.scss';
import emailjs from '@emailjs/browser';
import { Box, Button } from '@mui/material';
import SendIcon from '@mui/icons-material/Send';

function Contact() {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const [nameError, setNameError] = useState(false);
  const [emailError, setEmailError] = useState(false);
  const [messageError, setMessageError] = useState(false);

  const sendEmail = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    setNameError(name === '');
    setEmailError(email === '');
    setMessageError(message === '');

    if (name && email && message) {
      const templateParams = {
        name,
        email,
        message,
      };

      emailjs
          .send(
              'esra_serviceID_website',
              'esra_templateID_website',
              templateParams,
              'JpJS9DZUL-HAyY8fk'
          )
          .then(() => {
            alert('Message sent successfully!');
            setName('');
            setEmail('');
            setMessage('');
          })
          .catch((error) => {
            console.error('EmailJS Error:', error);
            alert('Oops, something went wrong. Please try again later.');
          });
    }
  };

  return (
      <div id="contact">
        <div className="items-container">
          <div className="contact_wrapper">
            <h1>Contact Me</h1>
            <p>Got a project waiting to be realized? Let's collaborate and make it happen!</p>

            <Box
                component="form"
                noValidate
                autoComplete="off"
                className="contact-form"
                onSubmit={sendEmail}
            >
              <div className="form-flex">
                <div className="form-group">
                  <label htmlFor="name">Your Name</label>
                  <input
                      type="text"
                      id="name"
                      name="name"
                      placeholder="What's your name?"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      className={nameError ? 'error' : ''}
                      required
                  />
                  {nameError && <small className="error-text">Please enter your name</small>}
                </div>

                <div className="form-group">
                  <label htmlFor="email">Email <span style={{ fontWeight: 'normal' }}>(required)</span></label>
                  <input
                      type="email"
                      id="email"
                      name="email"
                      placeholder="Enter your email address"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      className={emailError ? 'error' : ''}
                      required
                  />
                </div>
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                    id="message"
                    name="message"
                    placeholder="Send me any inquiries or questions"
                    rows={7}
                    value={message}
                    onChange={(e) => setMessage(e.target.value)}
                    className={messageError ? 'error' : ''}
                    required
                />
                {messageError && <small className="error-text">Please enter the message</small>}
              </div>

              <Button variant="contained" endIcon={<SendIcon />} type="submit">
                Send
              </Button>
            </Box>
          </div>
        </div>
      </div>
  );
}

export default Contact;
